import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, List, ListItem, ListItemText } from "@mui/material";

export const WELCOME_STORAGE_KEY = "tv_onboarding_completed";

export default function WelcomeOnboarding({ open, onStartTutorial, onSkip }) {
    return (
        <Dialog open={open} aria-labelledby="welcome-title" fullWidth maxWidth="sm">
            <DialogTitle id="welcome-title">
                Master Forex Patterns Through Rapid Recognition Training
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Takes 2 minutes to learn, lifetime to master.
                </Typography>
                <Box component={List} aria-label="key benefits">
                    <ListItem>
                        <ListItemText primary="Develop intuitive pattern recognition" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Practice thousands of scenarios quickly" />
                    </ListItem>
                    <ListItem>
                        <ListItemText primary="Get instant feedback on decisions" />
                    </ListItem>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onSkip} aria-label="Skip to Practice">
                    Skip to Practice
                </Button>
                <Button variant="contained" onClick={onStartTutorial} aria-label="Start Tutorial">
                    Start Tutorial
                </Button>
            </DialogActions>
        </Dialog>
    );
}


